import { render } from "./Voting.vue?vue&type=template&id=073ad21e&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"

import "./Voting.vue?vue&type=style&index=0&id=073ad21e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-073ad21e"

export default script